import React from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import ClickOutside from 'rechat-react-click-outside'
import styled from 'styled-components'

import { getCountryStates, UpdateCustomerAddress } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../../decl'

const EditCustomerAddress = (props) => {
  const { handleClose, customer_id, address, countries, addressType } = props
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    first_name: '',
    last_name: '',
    address1: '',
    address2: '',
    phone: '',
    city: '',
    state: '',
    zip: '',
    is_default: false,
    alternative_phone: '',
    fax: '',
    country: address?.country,
    address_type: addressType?.toLowerCase(),
    customer_id: customer_id,
    address_id: address.address_id,
  })

  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [states, setStates] = React.useState({
    US: [],
    PK: [],
  })

  React.useEffect(() => {
    if (states.US.length === 0 || states.PK.length === 0)
      getCountryStates(data.country).subscribe((res: any) => {
        if (res.response._meta.country === 'US') {
          setStates({ ...states, US: res.response.data })
        } else if (res.response._meta.country === 'PK') {
          setStates({ ...states, PK: res.response.data })
        }
      })
  }, [data.country])
  React.useEffect(() => {
    setData({
      first_name: address.first_name || '',
      last_name: address.last_name || '',
      address1: address.address1 || '',
      address2: address.address2 || '',
      phone: address.phone || '',
      city: address.city || '',
      state: address.state_code || '',
      zip: address.zip || '',
      is_default: false,
      alternative_phone: address?.alternative_phone || '',
      fax: address?.fax || '',
      country: address?.country || countries.default,
      address_type: addressType?.toLowerCase(),
      customer_id: customer_id,
      address_id: address.address_id,
    })
  }, [address])

  const stateOptions = () => {
    if (data.country === 'PK') {
      return [
        {
          name: 'Select State',
          code: '',
        },

        ...states.PK,
      ].map((p) => {
        return {
          label: p.name,
          value: p.code,
        }
      })
    } else if (data.country === 'US') {
      return [
        {
          name: 'Select State',
          code: '',
        },

        ...states.US,
      ].map((p) => {
        return {
          label: p.name,
          value: p.code,
        }
      })
    }
  }

  const editCustomerAddress = () => {
    showPageLoader()
    UpdateCustomerAddress(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.address_id) {
        showSuccess('Successfully Updated')

        handleClose(res.response)
      } else {
        if (res.response?.error && res.response?.field) {
          setError({
            error: res.response?.error,
            field: res.response?.field,
          })
        } else {
          showFailure(res.response?.error)
        }
      }
    })
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    editCustomerAddress()
  }
  return (
    <ClickOutside ClickOutside onClickOutside={() => [handleClose()]}>
      <Form onSubmit={handleSubmit}>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              First Name
            </DcText>
            <DcInput
              error={
                error.field === 'first_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'first_name'}
              placeholder={'First Name'}
              value={data.first_name}
              onChange={(e) => setData({ ...data, first_name: e.target.value })}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Last Name
            </DcText>
            <DcInput
              error={
                error.field === 'last_name' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'last_name'}
              placeholder={'Last Name'}
              value={data.last_name}
              onChange={(e) => setData({ ...data, last_name: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Address Line 1
            </DcText>
            <DcInput
              error={
                error.field === 'address1' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'address1'}
              placeholder={'Address Line 1'}
              value={data.address1}
              onChange={(e) => setData({ ...data, address1: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Address Line 2
            </DcText>
            <DcInput
              error={
                error.field === 'address2' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'address2'}
              placeholder={'Address Line 2'}
              value={data.address2}
              onChange={(e) => setData({ ...data, address2: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Phone
            </DcText>
            <DcInput
              error={
                error.field === 'phone' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'phone'}
              placeholder={'Phone'}
              value={data.phone}
              onChange={(e) => setData({ ...data, phone: e.target.value })}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Alternate Phone
            </DcText>
            <DcInput
              error={
                error.field === 'alternate_phone' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'alternate_phone'}
              placeholder={'Alternate Phone'}
              value={data.alternative_phone}
              onChange={(e) =>
                setData({ ...data, alternative_phone: e.target.value })
              }
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Fax
            </DcText>
            <DcInput
              error={
                error.field === 'fax' && error.error !== '' ? error.error : null
              }
              type={'text'}
              name={'fax'}
              placeholder={'Fax'}
              value={data.fax}
              onChange={(e) => setData({ ...data, fax: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              City
            </DcText>
            <DcInput
              error={
                error.field === 'city' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'city'}
              placeholder={'City'}
              value={data.city}
              onChange={(e) => setData({ ...data, city: e.target.value })}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              State
            </DcText>
            <DcDropDown
              error={
                error.field === 'state' && error.error !== ''
                  ? error.error
                  : null
              }
              placeholder={'Select State'}
              options={stateOptions()}
              value={data.state}
              onChange={(e) => {
                setData({ ...data, state: e.target.value })
              }}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Country
            </DcText>
            <DcDropDown
              error={
                error.field === 'country' && error.error !== ''
                  ? error.error
                  : null
              }
              placeholder={'Select Country'}
              options={countries.list.map((p) => {
                return {
                  label: p.name,
                  value: p.two_letter_abbreviation,
                }
              })}
              value={data.country}
              onChange={(e) => {
                setData({ ...data, country: e.target.value })
              }}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox height="auto" gap="10px">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Zip Code
            </DcText>
            <DcInput
              error={
                error.field === 'zip' && error.error !== '' ? error.error : null
              }
              required
              parentStyle={{
                width: '50%',
              }}
              type={'text'}
              name={'zip'}
              placeholder={'Zip Code'}
              value={data.zip}
              onChange={(e) => setData({ ...data, zip: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox justifyContent="flex-end" height="auto" padding="10px 0 0 0">
          <DcButton
            style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
            variant="primary"
            type="submit"
            size="sm"
          >
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </DcFlexBox>
      </Form>
    </ClickOutside>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
`

export default EditCustomerAddress
